export default __webpack_public_path__ + "static/media/c010-2.86064d58.png";